module.exports = __webpack_public_path__ + "img/round-group-24px.acc2e8bf.svg";